import { awsApiInstance } from '../api/aws-api';
import { encryptData } from '../auth/encrypt-data';
import { cognitoError } from '../types/types';
import { resetPasswordAfterSignUp } from './passwordreset';

/**
 * Resets the lost password
 * 
 * @returns void
 */
const ResetLostPassword = async () => {
  const resetPassword = document.querySelector('#aafp_resetpass-form') as HTMLFormElement;
  const resetPassButton = document.querySelector('#aafp_resetpass-button') as HTMLInputElement;
  const user = document.querySelector('#user_login') as HTMLInputElement;
  const code = document.querySelector('#aws_code') as HTMLInputElement;
  const passNew = document.querySelector('#new_password') as HTMLInputElement;
  const key = document.querySelector('#rp_key') as HTMLInputElement;

  if(!resetPassword) return;
  
  await cognitoResetPassword(user.value); 

  resetPassword.addEventListener('submit', async (event) => {
    event.preventDefault();
    event.stopPropagation();

    if ( resetPassword.checkValidity() ) {
      resetPassword.classList.remove('was-validated');
      resetPassword.classList.remove('form-control:valid');
      resetPassButton.classList.add('aafp_button-loading');

      try {
        const formattedData = `${user.value}:${code.value}:${passNew.value}`;
        const token = encryptData(formattedData);

        const modalData = { 
          request: JSON.stringify(token)
        };

        const { data } = await awsApiInstance.post('/auth/reset', modalData);

        if ( data && data.errorMessage ) {
          const cogResponse = JSON.parse(data.errorMessage);
          if ( cogResponse.statusCode === 500 ) {
            throw new Error(cogResponse.body?.message || 'An error occurred during password reset')
          }
        }

        const reset = await resetPasswordAfterSignUp(key.value, user.value, passNew.value);

        if ( reset.statusCode >= 400 ) {
          throw new Error(reset.body?.error || 'An error occurred with password reset')
        }

        location.href = '/member-login';
      } catch (error: any) {
        cognitoError.innerHTML = '';
        cognitoError.innerHTML = `<p>${error.message || error}</p>`;
        resetPassButton.classList.remove('aafp_button-loading');
      }
    } else {
      resetPassword.classList.add('was-validated');
    }
  }); 
}

/**
 * Sends a reset password request to AWS.  AWS sends a code to the user's email.
 * 
 * @param {string} user the user
 * 
 * @returns Promise
 */
const cognitoResetPassword = async (user: string) => {
  try {
    const key = encryptData(user);

    const modelData ={
      request: JSON.stringify(key)
    };

    const { data } = await awsApiInstance.post('/auth/email', modelData);

    return data;
  } catch ( error ) {
    console.log( error );
    cognitoError.innerHTML = '';
    cognitoError.innerHTML = `<p>Error Sending Verification code.  Please contact support.</p>`;
  }
}

export default ResetLostPassword;